import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { SignUp } from './SignUp';
import { SignUpSource } from './SignUpSource';

export const components = {
    Header() {
        return <Header />;
    },
    SignUp: {
        FormFields() {
            return <SignUp/>;
        }
    },
    Footer() {
        return <Footer />;
    },
};


export const componentsSource = {
    Header() {
        return <Header />;
    },
    SignUp: {
        FormFields() {
            return <SignUpSource/>;
        }
    },
    Footer() {
        return <Footer />;
    },
};